import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { ArrowLeft } from 'lucide-react';
import { Container } from '../../components/styled/Container';
import { PageLayout } from '../../components/styled/PageLayout';
import { pathWithRegion } from '../../utils/navBase';

const Back = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: ${({ theme }) => theme.fontClamp.sm};
  color: ${({ theme }) => theme.colors.mutedForeground};
  margin-bottom: 1.5rem;
  text-decoration: none;
  &:hover {
    color: ${({ theme }) => theme.colors.foreground};
  }
`;

const Title = styled.h1`
  margin: 0 0 1rem;
  font-size: ${({ theme }) => theme.fontClamp['3xl']};
  font-weight: 800;
  color: ${({ theme }) => theme.colors.foreground};
`;

const Prose = styled.div`
  font-size: ${({ theme }) => theme.fontClamp.sm};
  color: ${({ theme }) => theme.colors.mutedForeground};
  line-height: 1.7;
  max-width: 42rem;
  p {
    margin: 0 0 1rem;
  }
  ul {
    margin: 0 0 1rem;
    padding-left: 1.25rem;
  }
  a {
    color: ${({ theme }) => theme.colors.primary};
    font-weight: 600;
  }
`;

export default function StaticShell({ title, children, region }) {
  const home = pathWithRegion('/', region);
  return (
    <PageLayout>
      <Container style={{ paddingTop: '2.5rem', paddingBottom: '3rem' }}>
        <Back to={home}>
          <ArrowLeft size={18} /> Home
        </Back>
        <Title>{title}</Title>
        <Prose>{children}</Prose>
      </Container>
    </PageLayout>
  );
}
